import { observer } from 'mobx-react';
// import { useStore } from '../../../state/MobxContext';
import { useStore } from '../../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button, Card } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
// import { useEffect } from "react";
// import UserImage from "../Main/image/User.png";
// import EtherImage from "../Main/image/2089411.png"
// import StandImage from "../Main/image/Icon256.png"
// import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
// import { faSquareMinus } from '@fortawesome/free-solid-svg-icons';
import { toJS } from 'mobx';
import Slider from 'react-slick';
import CloverMarketCategoryBar from './CloverMarketCategoryBar';
import "../../../../node_modules/slick-carousel/slick/slick.css"
import "../../../../node_modules/slick-carousel/slick/slick-theme.css"
import MarketCategoryCard from './MarketCategoryCard';
import styled from "@emotion/styled";
import ProductCard from './ProductCard';
import CouponCard from './CouponCard';












function CloverMarket() {
  const { loginStore } = useStore();
  const { SaleStore } = useStore();
  // const { CoinStore } = useStore();


  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '80rem',
      height: "80rem",
      // minHeight: "25rem",
      minHeight: "auto",
      // backgroundColor:"#212121"

    },
    DialogMobile: {
      height: '100%',
      width: '100%',
      minWidth: "320px",
      padding: '0'
    },
    //CategoryImage
    CategoryImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '10rem',
      height: "5rem"
    },
    //CategoryImage
    BrandImage: {
      whiteSpace: "nowrap",
      objectFit: "cover",
      width: '12rem',
      height: "12rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");

  // let Clover_sale_count = SaleStore?.sale_clover_Token;

  // let User_Clover_Count = loginStore.CloverCount;

  let ProductListTable = toJS(SaleStore.ProductList);// item list
  // console.log(ProductListTable);

  let BrandTable = toJS(SaleStore.BrandTable);
  let CategoryTable = toJS(SaleStore.CategoryTable);


  let BrandCategory = SaleStore.market_category;
  let BrandChack = String(SaleStore.market_brand_chack);



  const WhiteTextTypography = withStyles({
    root: {
      color: "#FFFFFF",
      fontSize: "1.5rem"
    }
  })(Typography);

  const CategoryTypography = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1.2rem',
      }
  })(Typography);


  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
      }
  })(Typography);

  const isCloverMarketDialogOpen = loginStore?.isCloverMarketDialogOpen;
  let isUserMarketPage = SaleStore?.isUserMarketPage;
  let isUserCouponPage = SaleStore?.isUserCouponPage;

  let MemberCouponList = toJS(SaleStore?.member_coupon_list);

  let user_brand_chack_length = SaleStore?.user_brand_chack_length;

  const StyledSlider = styled(Slider)`
height: 100%;
width: 100%;
position: relative;
.slick-prev::before,
.slick-next::before {
  opacity: 0;
  display: none;
}`;

  const Pre = styled.div`
width: 30px;
height: 30px;
position: absolute;
left: ${isMobile ? "-8%" : "-4%"};
z-index: 3;
`;

  const NextTo = styled.div`
width: 30px;
height: 30px;
position: absolute;
right: ${isMobile ? "0%" : "-3%"};
z-index: 3;
`;

  const settings = {
    dots: true,
    // fade: true,
    infinite: true,
    autoplay: true,
    pauseOnHover: true,
    // centerMode: true,
    // centerPadding: '33rem',
    // variableWidth: true,
    speed: 500,
    autoplaySpeed: 5000,
    // slidesToShow: parseInt(test1) ,
    slidesToShow: user_brand_chack_length > 0 ? user_brand_chack_length : 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    nextArrow: (
      <NextTo />
    ),
    prevArrow: (
      <Pre />
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerMode: true,
          // centerPadding: '22rem',
          // infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerPadding: '3rem',
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // centerPadding: '1rem',
        }
      }
    ]
  };


  return (
    <div>
      <Dialog fullScreen={isMobile ? true : false} classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCloverMarketDialogOpen} onClose={loginStore.setDialogClose()}>
        <Box sx={isMobile ? { bgcolor: "#212121", width: "100%", height: "100%" } : { bgcolor: "#212121", width: "80rem", height: BrandChack !== "0" ? "auto" : "80rem" }}>
          <Box
            sx={isMobile ?
              { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', minWidth: '320px', height: '60px', }
              :
              { display: 'flex', bgcolor: 'black', width: '100%', height: '70px', }}
          >
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
              <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                <WhiteTextTypography >Market</WhiteTextTypography>
              </Grid>
              <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CloverMarketFalse") }} />
              </Grid>
            </Grid>
          </Box>

          <DialogContent sx={{ padding: 0, margin: 0 }} >


            <Box sx={isMobile ?
              { boxShadow: 5, bgcolor: "black", borderRadius: "6px", py: "0.1rem", marginBottom: "1rem", minWidth: "20.000rem", maxWidth: "37.500rem" }
              :
              { boxShadow: 5, bgcolor: "black", borderRadius: "6px", py: "0.5rem", marginBottom: "1rem" }}>
              <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-around' alignItems='center' >
                <Button onClick={() => { SaleStore?.setisUserMarketPage(true); }}>
                  <CategoryTypography>
                    Market
                  </CategoryTypography>
                </Button>
                <Button >
                  <CategoryTypography onClick={() => { SaleStore?.setisUserCouponPage(true, "ALL"); }} >
                    coupon
                  </CategoryTypography>
                </Button>
              </Grid>
            </Box>


            {isUserCouponPage === true &&
              <Box sx={isMobile ?
                { boxShadow: 5, bgcolor: "black", borderRadius: "6px", py: "0.1rem", marginBottom: "1rem", minWidth: "20.000rem", maxWidth: "37.500rem" }
                :
                { boxShadow: 5, bgcolor: "black", borderRadius: "6px", py: "0.5rem", marginBottom: "1rem" }}>
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-around' alignItems='center' >
                  <Button onClick={() => { SaleStore?.setisUserCouponPage(true, "ALL"); }}>
                    <CategoryTypography>
                      전체
                    </CategoryTypography>
                  </Button>
                  <Button >
                    <CategoryTypography onClick={() => { SaleStore?.setisUserCouponPage(true, "N"); }} >
                      사용 가능
                    </CategoryTypography>
                  </Button>
                  <Button >
                    <CategoryTypography onClick={() => { SaleStore?.setisUserCouponPage(true, "Y"); }} >
                      사용
                    </CategoryTypography>
                  </Button>
                  <Button >
                    <CategoryTypography onClick={() => { SaleStore?.setisUserCouponPage(true, "C"); }} >
                      취소
                    </CategoryTypography>
                  </Button>
                  
                </Grid>
              </Box>
            }


            {isUserMarketPage === true &&
              <Box sx={isMobile ?
                { boxShadow: 5, bgcolor: "black", borderRadius: "6px", py: "0.1rem", marginBottom: "1rem", minWidth: "20.000rem", maxWidth: "37.500rem" }
                :
                { boxShadow: 5, bgcolor: "black", borderRadius: "6px", py: "0.5rem", marginBottom: "1rem" }}>
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-around' alignItems='center' >
                  {CategoryTable.length > 0 &&
                    CategoryTable.map((Category) => (
                      <Grid key={Category.Index}>
                        <Button onClick={() => { SaleStore.setMarketGoodsCategory(Category.Index) }}>
                          <CategoryTypography>
                            {Category.GoodsCategory}
                          </CategoryTypography>
                        </Button>
                      </Grid>
                    ))}
                </Grid>
              </Box>

            }

            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'
              sx={{ marginBottom: "2rem", marginLeft: "1rem" }}
            >
              <div style={isMobile ? { width: "85%", maxWidth: "100%" } : user_brand_chack_length < 5 ? { width: "50%", maxWidth: "60%" } : { width: "80%", maxWidth: "80%" }}>
                <Slider {...settings} >
                  {BrandTable.length > 0 &&
                    BrandTable.map((BData) => (
                      BData?.Category === BrandCategory &&
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='flex-start' alignItems='center' key={BData.Index}>
                        <MarketCategoryCard key={BData.Index} item={BData} />
                      </Grid>

                    ))}
                </Slider>
              </div>
            </Grid>





            {BrandChack !== "0" &&
              <div style={{ width: "100%" }}>
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' gap={0.5}  >
                  <Box
                    sx={isMobile ?
                      {
                        // width: "100%",
                        // bgcolor: "white",
                        maxWidth: "30rem",
                        overflowY: "auto",
                        maxHeight: "300px",
                        display: "flex",
                        flexGrow: 1,
                        flexDirection: "column",
                        margin: 0,
                        padding: 0,
                      }
                      :
                      {
                        // width: "60%",
                        maxWidth: "90%",
                        // bgcolor: "white",
                        display: "flex",
                        maxHeight: '100vh',
                        flexGrow: 1,
                        flexDirection: "column",
                        margin: 0,
                        padding: 0,
                      }}
                  >
                    <Grid container direction='row' justifyContent={isMobile ? 'flex-start' : 'center'} alignItems='flex-start'
                      style={isMobile ? { paddingLeft: "1rem" } : {}}
                    >
                      {ProductListTable.length > 0 &&
                        ProductListTable.map((Branditem) => (
                          parseInt(Branditem?.Brand) === parseInt(BrandChack) &&
                          // <Grid container key={Branditem.Index} direction='row' >
                          <ProductCard key={Branditem.Index} item={Branditem} />
                          // </Grid>
                        ))
                      }
                    </Grid>
                  </Box>
                </Grid>
              </div>
            }


            <Box>
              <Grid container direction='row' justifyContent={isMobile ? 'flex-start' : 'center'} alignItems='flex-start'
                style={isMobile ? { paddingLeft: "2rem" } : {}}
              >
                {isUserCouponPage === true &&
                  MemberCouponList.length > 0 &&
                  MemberCouponList.map((Couponitem) => (
                    <CouponCard key={Couponitem.id} item={Couponitem} />
                  ))

                }
              </Grid>
            </Box>

          </DialogContent>


        </Box>
      </Dialog>
    </div>
  );
};

export default observer(CloverMarket);


